import React,{useEffect,useRef,useState} from "react";
import {createPortal} from "react-dom";
import {resolveUiLanguage} from "../../site/ui-language.js";
import {getCachedSession,refreshSession} from "./client-cache.js";
import TutorialVideo from "./TutorialVideo.jsx";
import {dismissTutorial,TUTORIAL_STORAGE} from "./tutorial-copy.js";

export default function CourseInvite({level="b1",navigate}){
 const [user,setUser]=useState(null),dialog=useRef(null);
 useEffect(()=>{
  let active=true;
  const apply=payload=>{
   if(!active||!payload?.user?.email)return;
   try{const saved=JSON.parse(localStorage.getItem(TUTORIAL_STORAGE+payload.user.email)||"{}");if(saved.dismissedAt||saved.completedAt)return;}catch{}
   setUser(payload.user);
  };
  apply(getCachedSession());refreshSession().then(apply).catch(()=>{});
  return()=>{active=false;};
 },[]);
 useEffect(()=>{
  if(!user||!dialog.current)return;
  const node=dialog.current,previous=document.activeElement;
  node.showModal();document.documentElement.classList.add("zd-video-welcome-open");
  return()=>{node.close();document.documentElement.classList.remove("zd-video-welcome-open");if(previous?.isConnected)previous.focus?.({preventScroll:true});};
 },[user]);
 if(!user)return null;
 const libraryUrl=`/library?level=${level}`,skip=()=>{dismissTutorial(user);setUser(null);navigate(libraryUrl);};
 return createPortal(<dialog ref={dialog} className="zd-video-welcome" aria-label="ZDeutsch" onCancel={event=>{event.preventDefault();skip();}}><TutorialVideo language={resolveUiLanguage(user.nativeLanguage)} libraryUrl={libraryUrl} onSkip={skip} dialog/></dialog>,document.body);
}
